<p-select
  [options]="languageOptions"
  [(ngModel)]="selectedLanguage"
  placeholder="Select Language"
  (onChange)="onLanguageChange($event)"
>
</p-select>
